export class SocialsDTO {
  constructor() {
    this.bluesky = null;
    this.discord_contact = null;
    this.discord_server = null;
    this.facebook = null;
    this.farcaster = null;
    this.instagram = null;
    this.telegram_channel = null;
    this.telegram_contact = null;
    this.twitch = null;
    this.x = null;
    this.youtube = null;
  }
}